import * as React from 'react';
import { DefaultLoader } from './default/defaultLoader';
import * as styles from './loader.scss';

export const TOUR_LOADER_WRAPPER_ID = 'tour-loader-wrapper';

export interface TourLoaderWrapperProps {
  show: boolean;
  component?: React.ComponentType;
}

export class TourLoaderWrapper extends React.Component<TourLoaderWrapperProps> {
  renderLoader() {
    const loaderComponent = this.props.component || DefaultLoader;
    return React.createElement(loaderComponent);
  }

  render() {
    return (
      <div id={TOUR_LOADER_WRAPPER_ID} className={styles.LoaderWrapper}>
        {this.props.show && this.renderLoader()}
      </div>
    );
  }
}
